import Box from 'components/ui/box';
import Button from 'components/ui/button';
import { useAuth } from 'context/AuthContext';
import { useEffect, useState } from 'react';
import { TbMailFast } from 'react-icons/tb';
import { FiChevronRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { canAccessExperienceCatalog } from 'utils/experience-catalog';

export default function Nav() {
  const { user, userInfo } = useAuth();
  const [isGestor, setIsGestor] = useState(false);
  const [hasTeam, setHasTeam] = useState(false);

  const URLs: any = [
    {
      title: 'Galeria de reconhecimento',
      url: '/galeria',
    },

    {
      title: 'Destaques',
      url: '/destaques',
    },
    {
      title: 'Pontos Livelo',
      url: '/catalogo-de-experiencias',
    },
    canAccessExperienceCatalog(userInfo) && {
      title: 'Catálogo de experiências',
      url: '/catalogo-de-experiencias-list',
    },
    hasTeam && {
      title: 'Minha Equipe',
      url: '/minha-equipe',
    },
    {
      title: 'Rede JogaJunto',
      url: '/rede-joga-junto',
    },
    // {
    //   title: 'Catálogo de experiências',
    //   url: '/experiencias',
    // },
    {
      title: 'Regras',
      url: '/regulamento',
    },
    {
      title: 'Nosso Manifesto',
      url: '/manifesto',
    },
  ].filter(Boolean);

  useEffect(() => {
    if (!!userInfo && !!user) {
      setIsGestor(
        !!userInfo.is_manager ||
          userInfo.tipo_ro === 'GERENCIAL' ||
          userInfo.funcao === 'DIRETOR' ||
          (Array.isArray(userInfo?.mad_dupla) &&
            userInfo?.mad_dupla?.some((md: any) => typeof md.tipo_ro === 'string' && md.tipo_ro === 'GERENCIAL')),
      );

      setHasTeam(
        !!userInfo.is_manager &&
          (!!userInfo.team || (Array.isArray(userInfo?.mad_dupla) && userInfo?.mad_dupla?.some((md: any) => md.team === true))),
      );
    }
  }, [user, userInfo]);

  return (
    <div id="nav">
      <ul className="space-y-6">
        {/* <li className="pb-4">
          <Link
            to="/convidar"
            className="font-normal leading-none text-lg hover:text-yellow focus:text-yellow active:text-yellow text-yellow flex items-center justify-center space-x-2"
          >
            <TbMailFast className="text-[2rem]" />{' '}
            <span className="font-normal leading-none text-lg">
              Convide seus amigos!
            </span>
          </Link>
        </li> */}

        {/* <Link
          to="/votacao"
          className="text-2xl font-normal leading-none hover:text-yellow focus:text-yellow active:text-yellow text-yellow flex items-center justify-center space-x-2 mb-3"
        >
          <MdContentPasteSearch className="text-[2.5rem]" />{' '}
          <span className="text-2xl font-normal leading-none">
            Escolha a nova
            <br /> logo do Joga Junto
          </span>
        </Link> */}

        {/* <a
          className="flex items-center justify-between text-base uppercase font-normal text-[#C2D2FF]"
          href="https://banco365.sharepoint.com/sites/NovoJogaJuntoBB"
          target="_blank"
          rel="noreferrer"
        >
          Hotsite JogaJunto BB <FiChevronRight className="text-xl" />
        </a> */}

        {URLs.map((item: any) => (
          <li key={item.url}>
            <Link to={item.url} className="flex items-center justify-between text-base uppercase font-normal text-[#C2D2FF]">
              {item.title} <FiChevronRight className="text-xl" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
